import React from 'react';
import { DETAILS_CONTENT_KEYS, IPlanContent } from '../typings';
import { createPlanNameMatcher, getKeyDetailsContentIcon } from './utils/PlanMetaHelper';
import { PlanKeyDetailsModal } from './common/PlanKeyDetailsModal';
import {
  defaultEstimatesDialog,
  businessDualKeyDetailsAddons,
  businessElectricityKeyDetailsAddons,
} from './common/planDefaults';
import { Text, TextLink } from '@origin-digital/ods-core';
import { BYOBattery } from './common/BYOBatteryModal';

const PLAN_TONE = 'promoteB';

const solarInfoContent = (
  <Text>
    With Origin Business Solar Boost Plus, you must purchase an eligible solar PV system from us,
    your solar PV system must be net metered. You must not be receiving a feed-in tariff under any
    government scheme. You’ll receive the total feed-in tariff until you reach your export cap for
    each billing period. For every kWh of electricity exported to the grid above your export cap
    during your billing period, you’ll receive our standard retailer feed-in tariff available at the
    time as published on our website. Your export cap for each billing period is calculated by
    multiplying the number of days in your billing period by 14 kWh. When your energy plan ends,
    you’ll receive our standard retailer feed-in tariff. Feed-in tariff rates are GST inclusive
    (where applicable). For Victorian customers, the 
    <TextLink
      href="https://www.originenergy.com.au/terms-and-conditions/vic-feed-in-tariff/"
      target="_blank"
    >
      Terms and Conditions for Feed-in Tariffs - Victoria
    </TextLink>
     apply to both the additional feed-in tariff and standard retailer feed-in tariff.
  </Text>
);

export const originBusinessSolarBoostPlus: IPlanContent = {
  test: createPlanNameMatcher(['Origin Business Solar Boost Plus']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 24 month energy plan',
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: [
          {
            contentKey: DETAILS_CONTENT_KEYS.Rates,
            contentValue: 'Variable',
            modalContent: PlanKeyDetailsModal,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Rates),
            contentDescription: 'Variable rates',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.ExitFees,
            contentValue: 'No',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.ExitFees),
            contentDescription: 'No exit fees. Leave anytime.',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
            contentValue: '24 months',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
            contentDescription: '24 month benefit period',
          },
        ],
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: [
          ...businessDualKeyDetailsAddons,
          {
            contentKey: DETAILS_CONTENT_KEYS.BYOBattery,
            contentValue: 'Register',
            modalContent: BYOBattery,
            // for plan card redesign in sales-monorepo only
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BYOBattery),
            contentDescription: 'BYO battery for extra value',
          },
        ],
        electricity: [
          ...businessElectricityKeyDetailsAddons,
          {
            contentKey: DETAILS_CONTENT_KEYS.BYOBattery,
            contentValue: 'Register',
            modalContent: BYOBattery,
            // for plan card redesign in sales-monorepo only
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BYOBattery),
            contentDescription: 'BYO battery for extra value',
          },
        ],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'purple',
              odsCore: PLAN_TONE,
            },
            promobox: {
              styleGuide: 'purple',
              odsCore: PLAN_TONE,
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
        },
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions.html',
      },
    },
    estimatesDialog: defaultEstimatesDialog({ customerType: 'business' }),
    solarInfo: {
      defaultState: {
        defaultFuel: {
          title: 'Origin Business Solar Boost Plus',
          content: solarInfoContent,
        },
      },
    },
  },
};
